import { useUser } from '../contexts/UserContextNew'

/**
 * Hook that returns the effective user data for the current session.
 * When mirroring, returns the mirrored user's data.
 * When not mirroring, returns the actual logged-in user's data.
 * 
 * Use this instead of useUser() when you need data that should respect mirroring.
 */
export const useEffectiveUser = () => {
  const { 
    user, 
    userProfile, 
    effectiveUserProfile, 
    effectiveUserId,
    mirroredUser,
    loading 
  } = useUser()

  return {
    // The user ID to use for all data operations
    userId: effectiveUserId,
    
    // The user profile to display and use
    profile: effectiveUserProfile,
    
    // Whether we're currently mirroring
    isMirroring: Boolean(mirroredUser),
    
    // The actual logged-in user (for admin operations)
    actualUser: user,
    actualProfile: userProfile,
    
    // Loading state
    loading
  }
}